module.exports = __webpack_public_path__ + "media/bootstrap-icons/grid-3x2-gap-801d28c2.svg";